import { http } from "./client";

export const fetchApplicationStatusHistory = (ApplicationID,ShowVoids = false,ShowInformationOnly = true) =>
    http.get('Applications/Status',{params: {ApplicationID,ShowVoids,ShowInformationOnly}});

export const fetchApplicationStatusTransitionSummary = (ApplicationID) =>
    http.get('Applications/Status/transition-summary',{params: {ApplicationID}});

export const fetchApplicationStatusDefinitions = () =>
    http.get('Applications/Status/definitions');

export const fetchApplicationStatus = (ApplicationID,StatusID) =>
    http.get('Applications/Status/get',{params: {ApplicationID,StatusID}});

export const applicationStatusAdd = (payload) =>
    http.post('Applications/Status/add',payload);

export const applicationStatusUpdate = (payload) =>
    http.patch('Applications/Status/update',payload);

export const applicationStatusVoid = (payload) =>
    http.patch('Applications/Status/void',payload);

export const getHistory = (ApplicationID) =>
    fetchApplicationStatusHistory(ApplicationID,false,true);
